import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取字典列表 get
 * @param query 分页参数
 * @return request
 * */
export function getDictList(query) {
    return request({
        url: `${baseURL.userApi}/dicts/get`,
        method: 'get',
        params: query
    })
}

/**
 * 查询字典树
 * @param query
 * @returns {AxiosPromise}
 */
export function getDictTreeList(query) {
    return request({
        url: `${baseURL.userApi}/dicts/back/tree`,
        method: 'get',
        params: query
    })
}

/**
 * 增加字典 post
 * @param data 增加的数据
 * @return request
 * */
export function addDict(data) {
    return request({
        url: `${baseURL.userApi}/dicts`,
        method: 'post',
        data: data
    })
}

/**
 * 删除字典  delete
 * @param id 字典id
 * @return request
 * */
export function deleteDict(id) {
    return request({
        url: `${baseURL.userApi}/dicts/${id}`,
        method: 'delete'
    })
}

/***
 * 修改字典 Post
 * @param id 要修改的字典id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateDict(id, data) {
    return request({
        url: `${baseURL.userApi}/dicts/${id}`,
        method: 'post',
        data: data
    })
}

/**
 * 根据字典key 搜索
 * @param key 搜索关键词
 * @return request
 * */
export function selectDictByKey(key) {
    return request({
        url: `${baseURL.userApi}/dict/getKey/${key}`,
        method: 'get'
    })
}

/**
 * 查询字典树
 * @param key
 * @returns {AxiosPromise}
 */
export function getDictsTree(key) {
    return request({
        url: `${baseURL.userApi}/dicts/tree?keyword=${key}`,
        method: 'get'
    })
}
